import React, { useState } from "react";
import { motion } from "framer-motion";
import { WEBSITE_DETAILS } from "@/config";
import { openExternalLink } from "@/utils/contactActions";
import { Whatsapp } from "../icons/HDSocialIcons";

const FloatingWhatsApp = () => {
    const handleWhatsAppClick = () => {
        openExternalLink(WEBSITE_DETAILS.socialMedia.whatsapp)
    };

    return (
        <div className="hidden sm:fixed bottom-6 right-6 z-50 sm:flex flex-col items-end gap-2">
            <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={handleWhatsAppClick}
                className="bg-white text-white p-4 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300 relative group"
                aria-label="Chat on WhatsApp"
            >
                <img src={Whatsapp} className="h-10 w-10" alt="whatsapp" />
                <span className="absolute inset-0 rounded-full bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300"></span>
                <span className="absolute top-1 right-1 flex h-4 w-4">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500"></span>
                </span>
            </motion.button>
        </div>
    );
};

export default FloatingWhatsApp;
